/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import slugify from 'slugify'
import TabsNavigation from 'components/TabsNavigation'
import ScreenshotReviews from 'pagesNew/ScreenshotReviews'
import Testimonials from 'pagesNew/Testimonials'
import NotFound from 'components/NotFound'
import { TabsItem } from 'types/tabsItem'
import { PlatformSlug } from 'constants/consts'
import { CommonElementTabs } from './consts'
import { CommonElementsConfig, getCommonElementsConfig, isCommonElementsAvailable } from './platformConfig'
import * as classes from './styles'

const COMMON_ELEMENT_PARAM = 'entity'

const getTabs = (config?: CommonElementsConfig): TabsItem[] =>
  (Object.values(CommonElementTabs) as CommonElementTabs[])
    .filter((title) => config?.[title])
    .map((title) => ({ id: slugify(title), title }))

const CommonElements: FC = () => {
  const { platform } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()

  const platformSlug = platform as PlatformSlug
  const tabs = getTabs(getCommonElementsConfig(platformSlug))

  const [activeTab, setActiveTab] = useState<TabsItem>(() => {
    const initialParamId = slugify(searchParams.get(COMMON_ELEMENT_PARAM) || '')

    if (initialParamId) {
      const selectedTab = tabs.find(({ id }) => id === initialParamId)

      return selectedTab || tabs[0]
    }

    return tabs[0]
  })

  const renderTab = () => {
    const { title } = activeTab
    if (title === CommonElementTabs.TESTIMONIALS) {
      return <Testimonials />
    }

    if (title === CommonElementTabs.SCREENSHOT_REVIEWS) {
      return <ScreenshotReviews />
    }
  }

  const handleChangeTab = (newTab: TabsItem) => {
    setActiveTab(newTab)

    searchParams.set(COMMON_ELEMENT_PARAM, newTab.id)
    setSearchParams(searchParams, { replace: true })
  }

  if (!isCommonElementsAvailable(platformSlug) || !tabs.length || !activeTab) {
    return <NotFound />
  }

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        Common Elements
      </Typography>
      <TabsNavigation tabs={tabs} value={activeTab} onChange={handleChangeTab} css={classes.tabs} />
      {renderTab()}
    </div>
  )
}

export default CommonElements
